module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAUCAYAAACTQC2+AAAA5klEQVRIiWNkOr/nPwMdABM9LBnBFvEwMdPHooXy2gzdUqoMAswstLWIjZGRoUhMjuGmphVDpogMAwsjI20sggERFlaGKTLqDOfVzRnc+YRpZxEMaHFwM2xTMmDYpmTAoM3BTTuLYMCdT5jhgoY5wxw5TQZJVnbaWUQKID8ZMTAw7P/ynqH06W2G898/08aiaz++MpQ8u82w89NbovWQZNGbP78ZGl7cY5j99inDn/+klcVEWfTr/3+GvlePGFpf3mf48PcPSRbAACMx1QQPEzPDl39/ybIABohKdZRaQrRF1ADDzyIAnow7h1DOnHEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/wz_play.png
// module id = N9yp
// module chunks = 0